'use client';

import Icon from '@/components/ui/AppIcon';

const CATEGORIES = [
  'Excavators',
  'Mini Excavators',
  'Wheeled Loaders',
  'Backhoe Loaders',
  'Bulldozers',
  'Dump Trucks',
  'Articulated Dump Trucks',
  'Crushers',
  'Screeners',
  'Cranes',
  'Telehandlers',
  'Compactors & Rollers',
  'Generators',
  'Concrete Equipment',
  'Drilling & Piling',
  'Demolition Equipment',
  'Attachments',
  'Trucks & Trailers',
  'Plant Hire Equipment',
  'Parts & Accessories',
  'Commercial Vehicle 4x4s',
  'Other',
];

interface FilterToolbarProps {
  search: string;
  statusFilter: string;
  categoryFilter: string;
  conditionFilter: string;
  sortBy: string;
  onSearchChange: (v: string) => void;
  onStatusChange: (v: string) => void;
  onCategoryChange: (v: string) => void;
  onConditionChange: (v: string) => void;
  onSortChange: (v: string) => void;
}

export default function FilterToolbar({
  search, statusFilter, categoryFilter, conditionFilter, sortBy,
  onSearchChange, onStatusChange, onCategoryChange, onConditionChange, onSortChange
}: FilterToolbarProps) {
  const selectClass = "px-2 py-1.5 border border-[var(--color-border)] rounded text-sm bg-[var(--color-background)] text-[var(--color-foreground)] focus:outline-none focus:ring-2 focus:ring-[var(--color-ring)]";

  return (
    <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-lg p-3 mb-3 flex flex-wrap gap-2 items-center">
      <div className="relative flex-1 min-w-[180px]">
        <Icon name="MagnifyingGlassIcon" size={15} variant="outline" className="absolute left-2.5 top-1/2 -translate-y-1/2 text-[var(--color-muted-foreground)]" />
        <input
          type="text"
          value={search}
          onChange={e => onSearchChange(e.target.value)}
          placeholder="Search title or description..."
          className="w-full pl-8 pr-3 py-1.5 border border-[var(--color-border)] rounded text-sm bg-[var(--color-background)] text-[var(--color-foreground)] focus:outline-none focus:ring-2 focus:ring-[var(--color-ring)]"
        />
      </div>
      <select value={statusFilter} onChange={e => onStatusChange(e.target.value)} className={selectClass}>
        <option value="">All Status</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
        <option value="pending">Pending</option>
        <option value="sold">Sold</option>
      </select>
      <select value={categoryFilter} onChange={e => onCategoryChange(e.target.value)} className={selectClass}>
        <option value="">All Categories</option>
        {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
      </select>
      <select value={conditionFilter} onChange={e => onConditionChange(e.target.value)} className={selectClass}>
        <option value="">All Conditions</option>
        <option value="new">New</option>
        <option value="used">Used</option>
        <option value="refurbished">Refurbished</option>
      </select>
      <select value={sortBy} onChange={e => onSortChange(e.target.value)} className={selectClass}>
        <option value="newest">Newest</option>
        <option value="oldest">Oldest</option>
        <option value="price_asc">Price: Low to High</option>
        <option value="price_desc">Price: High to Low</option>
      </select>
      {(search || statusFilter || categoryFilter || conditionFilter) && (
        <button
          onClick={() => { onSearchChange(''); onStatusChange(''); onCategoryChange(''); onConditionChange(''); }}
          className="flex items-center gap-1 px-2 py-1.5 text-xs text-[var(--color-muted-foreground)] hover:text-[var(--color-foreground)] border border-[var(--color-border)] rounded transition-colors"
        >
          <Icon name="XMarkIcon" size={13} variant="outline" />
          Clear
        </button>
      )}
    </div>
  );
}